export default __webpack_public_path__ + "static/blog-image-4-1c01f0177b7afd85c0a688e77253885f.png";